<template>
  <div>
    <modal
      ref="dispenseModal"
      template="question"
      title="Você quer dispensar esse aviso de recoleta?"
      ref-name="dispenseModal"
      first-button-text="Não"
      :icon-enabled="true"
      second-button-text="Sim"
      :close-button-enabled="false"
      class="dispense-modal"
      @first-cta="closeDispenseModal()"
    >
      <md-radio
        v-model="reason"
        md-value="DISPENSADO_RECOLETAR"
        class="radio"
      >
        Estou ciente da necessidade de recoletas, mas não <br>
        realizarei no momento
      </md-radio>

      <md-radio
        v-model="reason"
        md-value="DISPENSADO_NOVA_OS"
        class="radio"
      >
        Realizarei a recoleta criando outra OS
      </md-radio>

      <div class="footer-modal">
        <button
          class="btn-modal outline"
          @click="closeDispenseModal()"
        >
          <svg-loader src="/static/images/site/icon-return.svg" />
          VOLTAR
        </button>

        <button
          :disabled="!reason || isLoading"
          class="btn-modal"
          :class="{ disabled: !reason, spinner: isLoading }"
          style="min-width: 213px;"
          @click="putDispenseRecollect()"
        >
          <Spinner v-if="isLoading" />
          <template v-else>
            <svg-loader
              src="/static/images/icon-cancel.svg"
              class="icon-cancel"
            />
            Dispensar Recoleta
          </template>
        </button>
      </div>
    </modal>
  </div>
</template>

<script>
import SvgLoader from '../common/SvgLoader.vue'
import Spinner from '@/components/common/Spinner'

import { mapActions } from 'vuex'

export default {
  name: 'DispenseModal',
  components: { SvgLoader, Spinner },
  props: {
    close: Function,
    id: {
      type: [Number, String],
      default: null
    }
  },
  data: () => ({
    reason: '',
    isLoading: false
  }),
  methods: {
    ...mapActions(['dispenseRecollect']),
    putDispenseRecollect() {
      this.isLoading = true
      const paramsList = {
        id: this.id,
        status: this.reason
      }
      this.dispenseRecollect(paramsList).then(() => {
        this.isLoading = false
        this.closeDispenseModal()
        this.$router.go()
      }).catch(error => {
        console.error('error -->', error)
        this.isLoading = false
        this.closeDispenseModal()
      })
    },

    closeDispenseModal() {
      this.reason = ''
      this.$children[0].$refs.dispenseModal.close()
    }
  },
  watch: {
    id(value) {
      this.$emit('update:id', value)
    }
  }
}
</script>

<style lang="scss">
.dispense-modal .md-dialog {
  max-width: 600px;
  max-height: 295px;

  .radio {
    .md-radio-container {
      border-color: #7f1a54 !important;
      &::after {
        background-color: #7f1a54 !important;
      }
    }
  }
  .footer-modal {
    display: flex;
    justify-content: space-between;
    align-content: center;
    margin-top: 30px;
  }
  .md-dialog-title {
    padding: 50px 80px 24px 80px;

    &.standard-modal__title {
      font-family: 'Exo 2' !important;
      font-size: 20px;
      font-weight: 700;
    }
  }
  .md-dialog-content {
    padding: 0px 80px;
  }
  .btn-modal {
    background-color: #bf0000;
    height: 40px;
    padding: 0 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-transform: uppercase;
    font-size: 13px;
    font-family: 'Exo 2', sans-serif;
    font-weight: 600;
    border-radius: 4px;

    &.outline {
      background-color: transparent;
      border: 2px solid #7f1a54;
      color: #7f1a54;
      margin-right: 10px;
      width: auto;
      padding: 0 30px;
    }

    &.disabled {
      background: #ffbfbf;
    }

    svg {
      width: 60%;
      margin-right: 5px;
      path {
        fill: #7f1a54 !important;
      }
    }

    &.dispense {
      background: #bf0000;

      &.disabled {
        cursor: not-allowed;
        background: #ffbfbf;
      }
    }

    &.spinner {
      pointer-events: none;

      .loader {
        font-size: 3px;
        border-color: rgba(255, 255, 255, 0.2);
        border-left: 1.1em solid #fff;
      }
    }
  }

  .btn {
    display: none !important;
  }
  .icon-cancel {
    > svg {
      width: 18px;
      height: 18px;
      color: white;
      path {
        fill: white !important;
      }
    }
  }
}
</style>
